// TODO: Move this question out of the dynamic-forms world
import { MultiSelectOption } from '@ot/shared/model';
import {
  QuestionBase,
  QuestionControlOptions
} from '../question-types/question-base';

export interface MultiSelectControlOptions<T>
  extends QuestionControlOptions<T[]> {
  options?: MultiSelectOption<T>[];
  optionsLabel?: string;
  selectedItemsLabel?: string;
  addButtonLabel?: string;
  resetButtonLabel?: string;
}

export class MultiSelectQuestion<T> extends QuestionBase<T[]>
  implements MultiSelectControlOptions<T> {
  controlType = 'multi-select';
  options: MultiSelectOption<T>[] = [];
  optionsLabel: string;
  selectedItemsLabel: string;
  addButtonLabel: string;
  resetButtonLabel: string;

  constructor(options: MultiSelectControlOptions<T>) {
    super(options);
    this.options = options.options || [];
    this.optionsLabel = options.optionsLabel || '';
    this.selectedItemsLabel = options.selectedItemsLabel || '';
    this.addButtonLabel = options.addButtonLabel || '';
    this.resetButtonLabel = options.resetButtonLabel || '';
  }
}
